import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Select from 'react-select';
import { defaultTo } from 'ramda';

import { handleError, handleSuccess } from '../../util/forms';
import { apiApproveExperience } from '../../api/experience';
import { apiGetEmailDropdownsForCategory } from '../../api/email';
import magic from '../../util/magic';

import Modal from '../Modal';
import EditField from '../Forms/EditField';

const propTypes = {
  experience: PropTypes.object,
};

class ApproveExperienceModal extends Component {
  state = {
    fetchMessageDropdown: false,
    messageDropdown: [],
  };

  loadingMessageDropdown = false;

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show) {
      return { show: defaultTo(false, nextProps.show), fetchMessageDropdown: true };
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fetchMessageDropdown && !this.loadingMessageDropdown) {
      this.loadingMessageDropdown = true;

      apiGetEmailDropdownsForCategory(magic.emailExperienceApproval)
        .then(({ data }) => this.setState({ messageDropdown: data.options, fetchMessageDropdown: false }))
        .catch((err) => console.error(err))
        .then(() => (this.loadingMessageDropdown = false));
    }
  }

  render() {
    const {
      onHide,
      experience,
      show,
      values,
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      registration,
      setFieldValue,
      status,
    } = this.props;
    const { messageDropdown } = this.state;

    return (
      <Modal show={show} onHide={() => onHide()} title="Approve Experience Hours">
        <Modal.Body>
          <EditField
            as={Select}
            bare
            block
            multi
            status={status}
            label="Approval Message (optional)"
            name="messageDropdown"
            onChange={(value) =>
              setFieldValue(
                'selectedMessages',
                value.map((choice) => choice.value),
              )
            }
            value={values.selectedMessages}
            options={messageDropdown.map((option) => ({ value: option.id, label: option.title }))}
            error={errors.messageDropdown}
          />
          <EditField
            block
            as="textarea"
            name="message"
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.message}
            error={errors.message}
          />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => onHide()}>
            Close
          </button>
          <button type="submit" className="btn btn-primary" disabled={!isValid || isSubmitting} onClick={handleSubmit}>
            Approve
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ApproveExperienceModal.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiApproveExperience(props.experience.id, payload)
      .then((resp) => {
        handleSuccess(formProps);
        return resp.data;
      })
      .then((newExperience) => props.onHide(newExperience))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: () => ({
    selectedMessages: [],
    message: '',
  }),
  isInitialValid: true,
})(ApproveExperienceModal);
